import React, { useEffect, useState } from "react";
import matter from "gray-matter";
import { Link } from "react-router-dom";
import { blogFiles } from "./content";

function Blog() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    document.title = "Writing - Soham Jog";
  }, []);

  useEffect(() => {
    async function fetchPosts() {
      const fetchedPosts = await Promise.all(
        blogFiles.map(async ({ slug, filePath }) => {
          const res = await fetch(filePath);
          const text = await res.text();
          const { data } = matter(text);
          return { slug, ...data };
        })
      );

      const sortedPosts = fetchedPosts.sort(
        (a, b) => new Date(b.date) - new Date(a.date)
      );

      setPosts(sortedPosts);
    }

    fetchPosts();
  }, []);

  return (
    <main className="mx-auto min-h-screen max-w-3xl px-6 pb-24 pt-16 sm:px-8">
      <header className="mb-12 space-y-4">
        <h1 className="text-5xl font-bold tracking-tight text-gray-900 sm:text-6xl">
          Writing
        </h1>
        <p className="max-w-2xl text-lg leading-8 text-gray-700">
          Notes on systems, software, and whatever else seems worth thinking
          through carefully.
        </p>
      </header>

      <div className="space-y-10">
        {posts.length === 0 ? (
          <div className="py-12 text-gray-500">Loading posts...</div>
        ) : (
          posts.map((post) => (
            <article
              key={post.slug}
              className="border-t border-gray-200 pt-10 first:border-t-0 first:pt-0"
            >
              <Link to={`/blog/${post.slug}`} className="group block space-y-2">
                <time className="text-sm text-gray-500">{post.date}</time>
                <h2 className="text-2xl tracking-tight text-gray-900 transition-colors group-hover:text-gray-700">
                  {post.title}
                </h2>
                <p className="text-base leading-7 text-gray-600">
                  {post.description}
                </p>
              </Link>
            </article>
          ))
        )}
      </div>
    </main>
  );
}

export default Blog;
